import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'gatsby-plugin-intl';
import Layout from '../../components/layout';
import GridClientesFromBaixeCatalogo from '../../components/GridClientesFromBaixeCatalogo';

export default ({ location }) => {
  const intl = useIntl();

  return (
    <Layout location={location}>
      <Helmet bodyAttributes={{ class: 'page-template page-template-page-cliente page-template-page-cliente-php page page-id-124 full-width custom-font-enabled single-author mob-menu-slideout' }}>
        <title>{intl.formatMessage({ id: 'Clientes | Ideia 2001' })}</title>
      </Helmet>

      <div id="primary" className="site-content">
        <div className="tituloProduto mt-5">
          <div className="container">
            <div className="row">
              <div className="col-md-12 pt-3 pb-3 contatoTitulo">
                <h1 className="tt-u m-0">{intl.formatMessage({ id: 'Clientes' })}</h1>
                <h2>{intl.formatMessage({ id: 'conheça quem já está com a gente!' })}</h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-5 mb-5">
          <div className="row">
            <div className="col-md-12" id="grid">
              <GridClientesFromBaixeCatalogo />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
